/**
 * **Quelle opération d'essai porte les relevés, après un repli.**
 *
 * ⚠️ **La règle tient en une ligne et se trompe en silence dans les deux sens.** Vider le contexte à
 * chaque repli ferait retomber tous les relevés suivants sur le repli serveur (la fenêtre de temps),
 * qui se trompe dès que deux manips se chevauchent ; ne jamais le vider ferait rattacher un relevé à
 * une opération que plus personne ne regarde. Aucun des deux ne lève quoi que ce soit : le relevé part,
 * le serveur répond, et c'est le **rattachement** qui est faux.
 *
 * ⚠️ **Elle vit dans `utils/` parce que c'est là que ce dépôt EXÉCUTE ses tests** (`jest.config` ne
 * collecte que `models/*.spec.ts` et `utils/*.spec.ts`). Un `.spec.ts` posé à côté du service n'aurait
 * jamais tourné — et un test qui ne tourne pas se lit comme un test qui protège.
 *
 * @param courante  l'opération que le contexte porte aujourd'hui
 * @param repliee   celle que l'utilisateur vient de replier
 * @returns         l'opération qui reste en vigueur, ou `null`
 */
export function operationApresRepli(
  courante: string | null,
  repliee: string,
): string | null {
  return courante === repliee ? null : courante;
}
